import { SerializedError } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";
import { DateTime } from "luxon";

import { PresetImagesService } from "@/api/services/interfaces";
import { lvtResponsePresetImagesValidator } from "@/api/validation/presetImages";
import { logError } from "@/utilities/api";
import { ArchiveImage } from "@/utilities/types/archive";

import { routes } from "../routes";


axios.defaults.withCredentials = true;

const client = applyCaseMiddleware(axios.create());

export const presetImagesService: PresetImagesService = {
    async fetchPresetImages(presetId: number, startTime: DateTime, endTime: DateTime): Promise<ArchiveImage[] | Error> {
        const route = routes.getPresetImages(presetId, startTime, endTime);

        try {
            const response = await client.get(route);

            if (lvtResponsePresetImagesValidator(response.data)) {
                return response.data.data as ArchiveImage[]; //TODO: conversion?
            } else {
                const error: SerializedError = {
                    name: "validation",
                    message: JSON.stringify(lvtResponsePresetImagesValidator.errors),
                };

                return error as Error;
            }
        } catch (error) {
            logError(route, error as Error);

            return error as Error;
        }
    },
    async fetchPresetsImages(
        presetIds: number[],
        startTime: DateTime,
        endTime: DateTime,
    ): Promise<ArchiveImage[] | Error> {
        const route = routes.getPresetsImages();

        try {
            const response = await client.post(route, {
                start: startTime.toUTC().toISO(),
                end: endTime.toUTC().toISO(),
                presetIds,
            });

            if (lvtResponsePresetImagesValidator(response.data)) {
                return response.data.data as ArchiveImage[]; //TODO: conversion?
            } else {
                const error: SerializedError = {
                    name: "validation",
                    message: JSON.stringify(lvtResponsePresetImagesValidator.errors),
                };

                return error as Error;
            }
        } catch (error) {
            logError(route, error as Error);

            return error as Error;
        }
    },
    async fetchPresetImagePresignedUrl(presetId: number): Promise<string | Error> {
        const route = routes.getPresignedUrl(presetId);

        try {
            const response = await client.get(route);

            console.log("The presigned url response: ", response.data.data);

            return response.data.data;
        } catch (error) {
            logError(route, error as Error);
            console.log("The presigned url ERROR response: ", error);

            return error as Error;
        }
    },
};

export const dummyPresetImagesService: PresetImagesService = {
    async fetchPresetImages(): Promise<ArchiveImage[] | Error> {
        const error = {
            name: "dummy",
            message: "Using the dummy service",
        };

        throw error;
    },
    async fetchPresetsImages(
        ): Promise<ArchiveImage[] | Error> {
            const error = {
                name: "dummy",
                message: "Using the dummy service",
            };

            throw error;
        },
    async fetchPresetImagePresignedUrl(): Promise<string | Error> {

        const error = {
            name: "dummy",
            message: "Using the dummy service",
        };

        throw error;
    },
};
